module.exports = __webpack_public_path__ + "img/img09.31edac9b.png";